import createVueApp from '@phoenix/createVueApp';
import LightCheckoutPanel from '@maison/components/light-checkout/LightCheckoutPanel.vue';

const app = createVueApp({}, true);
app.component('LightCheckoutPanel', LightCheckoutPanel);
app.mount('#phoenix-light-checkout-panel');
